<div class="header sticky-top">
  <p-menubar>
    <ng-template pTemplate="start">
      <p-button
        (click)="isSidebarVisible = !isSidebarVisible"
        icon="pi pi-bars"
        size="large"
        aria-label="Toggle sidebar menu"
        [attr.aria-expanded]="isSidebarVisible"
        [ngClass]="{ 'p-focus-visible': isFocused }"
        (focus)="isFocused = true"
        (blur)="isFocused = false"
        (keydown.enter)="
          $event.preventDefault(); isSidebarVisible = !isSidebarVisible
        "
        (keydown.space)="
          $event.preventDefault(); isSidebarVisible = !isSidebarVisible
        "></p-button>
      <div class="branding">
        <img
          [src]="environment.logoPath"
          alt="EY brand logo"
          class="branding-icon" />
        <span class="branding-text f-18">{{ environment.appName }}</span>
      </div>
    </ng-template>

    <ng-template #end>
      <div
        class="header-end1 d-flex align-items-center justify-content-end w-100">
        @if (shouldShowClientSelection) {
          <div
            class="d-flex flex-lg-row flex-fill justify-content-around"
            style="min-width: 150px">
            @if (showSwitchClientButton) {
              <p-button
                label="Switch Client"
                icon="pi pi-sync"
                size="small"
                type="button"
                class="f-12"
                (onClick)="switchClient()">
              </p-button>
            }
          </div>
          <span class="client-label f-14"><b>Client: </b>{{ clientName }}</span>
        }
        <div class="profile-section d-flex align-items-center">
          <p-menu
            styleClass="f-12 fw-light"
            #menu
            [popup]="true"
            [model]="menuItems"
            appendTo="body"
            baseZIndex="1200"></p-menu>
          <p-button
            (click)="menu.toggle($event)"
            (keydown.enter)="menu.toggle($event)"
            ariaLabel="Profile"
            class="">
            <p-avatar
              [label]="
                (profile?.givenName?.charAt(0)?.toUpperCase() || '') +
                (profile?.surname?.charAt(0)?.toUpperCase() || '')
              "
              size="normal"
              shape="circle"
              [style]="{
                'background-color': '#00796B',
                color: '#FFFFFF',
              }">
            </p-avatar>
            <span class="f-12 d-flex flex-column text-end ms-2">
              <span>{{
                (profile?.givenName || '' | pascalCase) +
                  ' ' +
                  (profile?.surname || '' | pascalCase)
              }}</span>
              @if (roleName) {
                <span><b>Role: </b>{{ roleName }}</span>
              }
            </span>
          </p-button>
        </div>
      </div>
    </ng-template>
  </p-menubar>
</div>

<app-left-navigation [(visible)]="isSidebarVisible"></app-left-navigation>
